import {
  Typo3SectionSpotHeadlessCtaImageVideo,
  Typo3SectionSpotSanityAccomodation,
  Typo3SectionSpotSanityCulture,
  Typo3SectionSpotSanityEatDrink,
  Typo3SectionSpotSanityEventList,
  Typo3SectionSpotSanityFreetime,
  Typo3SectionSpotSanityNature,
  Typo3SectionSpotSanityPressroom,
  Typo3SectionSpotSanityService,
  Typo3SectionSpotSanityShopping,
  Typo3SectionSpotSanitySport,
  Typo3SectionSpotSanitySportServices,
  Typo3SectionSpotSanityStory,
  Typo3SectionSpotSanityTour
} from '@/types/typo3'
import { SectionCtaSingleType } from '@/ui/Sections/SectionCtaSingle/type'

// TODO: Check link label for spotsanity_shopping, spotsanity_freetime, spotsanity_nature, spotsanity_service, spotsanity_sportservice
// TODO: Check tour openingStatus isToCalculateTheOpening and keyForNextOpeningDay

const toSectionCtaSingle = (
  section:
    | Typo3SectionSpotSanityEventList
    | Typo3SectionSpotSanityAccomodation
    | Typo3SectionSpotSanityStory
    | Typo3SectionSpotSanityEatDrink
    | Typo3SectionSpotSanityShopping
    | Typo3SectionSpotSanityFreetime
    | Typo3SectionSpotSanityNature
    | Typo3SectionSpotSanityService
    | Typo3SectionSpotSanitySportServices
    | Typo3SectionSpotSanityCulture
    | Typo3SectionSpotSanitySport
    | Typo3SectionSpotSanityTour
    | Typo3SectionSpotSanityPressroom
    | Typo3SectionSpotHeadlessCtaImageVideo
) => {
  const { type } = section

  if (type === 'spotsanity_eventlist') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.title,
      subTitle: `${section?.content?.items?.[0]?.contactText || ''} - ${section?.content?.items?.[0]?.textDates?.[0]?.firstActiveWithYear || ''}`,
      body: section?.content?.items?.[0]?.summary,
      button: {
        label: section?.content?.items?.[0]?.link?.title,
        ...section?.content?.items?.[0]?.link
      },
      chipContent: section?.content?.items?.[0]?.categories,
      variant: section?.content?.items?.[0]?.isTopEvent
        ? 'topEvent'
        : 'content',
      image: section?.content?.items?.[0]?.images?.[0]
    } as SectionCtaSingleType
  } else if (type === 'spotheadless_ctaimagevideo') {
    return {
      section: section,
      title: section?.content?.title,
      subTitle: section?.content?.subtitle,
      body: section?.content?.text,
      image: section?.content?.images?.[0],
      chipContent: section?.content?.overline,
      button: {
        label: section?.content?.button?.link?.title,
        ...section?.content?.button?.link
      }
    } as SectionCtaSingleType
  } else if (type === 'spotsanity_eatdrink') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.title,
      body: section?.content?.items?.[0]?.summary,
      button: {
        label: section?.content?.items?.[0]?.title,
        href: section?.content?.items?.[0]?.slug
      },
      coordinates: section?.content?.items?.[0]?.coordinates?.hasCoordinates
        ? {
            latitude: Number(
              section?.content?.items?.[0]?.coordinates?.latitude
            ),
            longitude: Number(
              section?.content?.items?.[0]?.coordinates?.longitude
            )
          }
        : null,
      openingStatus: section?.content?.items?.[0]?.openings,
      image: section?.content?.items?.[0]?.images?.[0]
    } as SectionCtaSingleType
  } else if (type === 'spotsanity_tour') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.title,
      body: section?.content?.items?.[0]?.summary,
      button: {
        label: section?.content?.items?.[0]?.link?.title,
        href: section?.content?.items?.[0]?.link?.href,
        target: section?.content?.items?.[0]?.link?.target
      },
      tourInfo: {
        distance: section?.content?.items?.[0]?.distanceFormatted,
        duration: section?.content?.items?.[0]?.durationFormatted,
        altitudeUphill: section?.content?.items?.[0]?.maxAltitude,
        altitudeDownhill: section?.content?.items?.[0]?.minAltitude
      },
      openingStatus: {
        weekOpenings: [],
        isOpenToday:
          section?.content?.items?.[0]?.liveStatus === 'OPEN' ? true : false,
        isOnRequest:
          section?.content?.items?.[0]?.liveStatus === 'ON_REQUEST'
            ? true
            : false,
        isUnknown:
          section?.content?.items?.[0]?.liveStatus === 'UNKNOWN' ? true : false
      },
      image: section?.content?.items?.[0]?.images?.[0]
    } as SectionCtaSingleType
  } else if (type === 'spotsanity_story') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.contentTeaser?.title,
      //subTitle: section?.content?.items?.[0]?.contentTeaser?.lead,
      body: section?.content?.items?.[0]?.contentTeaser?.summary,
      button: {
        label: section?.content?.items?.[0]?.link?.title,
        ...section?.content?.items?.[0]?.link
      },
      chipContent: section?.content?.items?.[0]?.category,
      image: section?.content?.items?.[0]?.images?.[0]
    } as SectionCtaSingleType
  } else if (type === 'spotsanity_pressroom') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.contentTeaser?.title,
      date: section?.content?.items?.[0]?.infoPublicationDate,
      body: section?.content?.items?.[0]?.contentTeaser?.summary,
      button: {
        label: section?.content?.items?.[0]?.link?.title,
        ...section?.content?.items?.[0]?.link
      },
      chipContent: section?.content?.items?.[0]?.category,
      image: section?.content?.items?.[0]?.images?.[0]
    } as SectionCtaSingleType
  } else if (type === 'spotsanity_accommodation') {
    return {
      section: section,
      title: section?.content?.items?.[0]?.title,
      body: section?.content?.items?.[0]?.summary,
      button: {
        label: section?.content?.items?.[0]?.title || 'Book now',
        href: section?.content?.items?.[0]?.slug
      },
      chipContent: section?.content?.overline,
      image: section?.content?.items?.[0]?.images?.[0]
    } as SectionCtaSingleType
  } else {
    return {
      section: section,
      title: section?.content?.items?.[0]?.title,
      body: section?.content?.items?.[0]?.summary,
      button: {
        label: section?.content?.items?.[0]?.link?.title,
        ...section?.content?.items?.[0]?.link
      },
      chipContent: section?.content?.overline,
      image: section?.content?.items?.[0]?.images?.[0]
    } as SectionCtaSingleType
  }
}

export default toSectionCtaSingle
